// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2_540","row":"ProcedureTreatmentSummary_row__3glT3"};